import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Card } from 'react-bootstrap';
import styles from './user-card.module.sass';
import * as React from 'react';
import { IUser } from '../../../model/user';
import { CustomSpinner } from '@yakoffice/custom-spinner';
import { useProjects, UserForm, useTools, useUser } from '../../../components';

export interface UserCardProps {
    user: IUser;
    updateCallbackTrigger: (clearActiveUser?: boolean) => void;
}

export const UserCard: FC<UserCardProps> = observer((props: UserCardProps) => {

    const loadToolsResult = useTools();
    const loadProjectsResult = useProjects();
    const loadUserResult = useUser(props.user.email);

    return (
        !loadUserResult.isLoaded || !loadProjectsResult.isLoaded || !loadToolsResult.isLoaded
            ? <CustomSpinner spinnerText="Loading User..." />
            : loadUserResult.user &&
            loadProjectsResult.projects &&
            loadToolsResult.tools &&
            <Card key={props.user.id} className={styles.userCard}>
                <Card.Body className={styles.cardBody}>
                    <UserForm projects={loadProjectsResult.projects} tools={loadToolsResult.tools}
                              user={loadUserResult.user}
                              updateCallbackTrigger={props.updateCallbackTrigger} />
                </Card.Body>
            </Card>
    );
});
